import { ReactNode } from 'react';

import { ErrorBoundary } from 'react-error-boundary';

import { ErrorMessage } from './messages/messages';

export const FullPageErrorBoundary = ({
	children,
}: {
	children: ReactNode;
}) => {
	return <ErrorBoundary fallback={<ErrorMessage />}>{children}</ErrorBoundary>;
};
